import { createSlice } from "@reduxjs/toolkit";
import type { PayloadAction } from "@reduxjs/toolkit";

import {
  StrainModal,
  StrainFilter,
  StrainsListing,
  StrainDetailsById,
  AssociatedBatchData,
  StrainsListingQueryParameters,
  AssociatedBatchListingQueryParameters,
} from "./type";

export const rewardInitialstate: StrainModal = {
  strainList: {
    data: [],
    total: 0,
    pageNo: 0,
    totalPage: 0,
    nextHit: 0,
    limit: 0,
  },

  strainListingQueryParameters: {
    pageNo: 1,
    limit: 10,
    searchKey: "",
  },

  strainFilter: {
    strainType: [],
    toDate: null,
    fromDate: null,
  },

  headerNameListing: [],

  strainDetails: {
    _id: "",
    strainId: "",
    imageUrl: "",
    strainName: "",
    lineage: [],
    description: "",
    strainType: "",
    feelings: [],
    status: "",
    rating: null,
    createdAt: null,
    averageRatingSumUp: 0,
  },

  dateRange: undefined,

  associatedBatchListing: {
    data: [],
    total: 0,
    pageNo: 0,
    totalPage: 0,
    nextHit: 0,
    limit: 0,
  },

  associatedBatchListingQueryParameters: {
    pageNo: 1,
    limit: 10,
  },
};
const RewardsManagementModuleSlice = createSlice({
  name: "rewards-management",
  initialState: rewardInitialstate,
  reducers: {
    setStrainListingData: (
      state: StrainModal,
      action: PayloadAction<StrainsListing>,
    ) => {
      state.strainList = { ...action.payload };
    },

    setStrainDetails: (
      state: StrainModal,
      action: PayloadAction<StrainDetailsById>,
    ) => {
      state.strainDetails = action.payload;
    },

    setStrainFilter: (
      state: StrainModal,
      action: PayloadAction<StrainFilter>,
    ) => {
      state.strainFilter = action.payload;
    },

    setHeaderNameListing: (
      state: StrainModal,
      action: PayloadAction<string[]>,
    ) => {
      state.headerNameListing = [...action.payload];
    },

    setStrainListingQueryParameters: (
      state: StrainModal,
      action: PayloadAction<StrainsListingQueryParameters>,
    ) => {
      state.strainListingQueryParameters = { ...action.payload };
    },

    setDateRange: (
      state: StrainModal,
      action: PayloadAction<[Date, Date] | undefined>,
    ) => {
      state.dateRange = action.payload;
    },

    setAssociatedBatchesListingData: (
      state: StrainModal,
      action: PayloadAction<AssociatedBatchData>,
    ) => {
      state.associatedBatchListing = { ...action.payload };
    },

    setAssociatedBatchesListingQueryParameters: (
      state: StrainModal,
      action: PayloadAction<AssociatedBatchListingQueryParameters>,
    ) => {
      state.associatedBatchListingQueryParameters = { ...action.payload };
    },
  },
});

export const {
  setDateRange,
  setStrainFilter,
  setStrainDetails,
  setStrainListingData,
  setHeaderNameListing,
  setAssociatedBatchesListingData,
  setStrainListingQueryParameters,
  setAssociatedBatchesListingQueryParameters,
} = RewardsManagementModuleSlice.actions;
export default RewardsManagementModuleSlice.reducer;
